import { SYSTEM_ERROR } from "../config/CONSTANT";
import axios from "axios";
import packageJson from "../../package.json";
export const BaseUrl = packageJson.projectURlApi.BaseUrl;
export const getAllCounteries = () => {
  return new Promise((resolve, reject) => {
    try {
      const config = {
        headers: { "Content-Type": "application/json", Authorization: null },
      };
      axios
        .get(
          `${BaseUrl}/sanctum/csrf-cookie`,
          config
        )
        .then((response) => {
          axios
            .get(
              `${BaseUrl}/api/countries`,
              {
                withCredentials: true,
              }
            )
            .then((res) => {
              resolve(res.data);

              const Id = res.data.data[0].id;
              axios
                .get(
                  `${BaseUrl}/api/country/${Id}/cities`,
                  {
                    withCredentials: true,
                  }
                )
                .then((rescities) => {
                  resolve(rescities.data);
                });
            })
            .catch((err) => {
              reject("Error in getAllTrips axios!");
            });
        });
    } catch (error) {
      console.error("in tripServices > getAllTrips, Err===", error);
      reject(SYSTEM_ERROR);
    }
  });
};
